import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ConfiguracaoAusente } from './componentes/ConfiguracaoAusente';
import { leituraDaConfiguracao } from './config';

// A ordem importa: tokens antes de temas (que sobrescrevem só os acentos),
// depois base, depois componentes. CSS em cascata é ordem, não opinião.
import './estilo/tokens.css';
import './estilo/temas.css';
import './estilo/base.css';
import './estilo/componentes.css';

// O painel é `purpura`, fixo: uma aplicação, um acento. Fica no `<html>` para
// que o anel de foco tenha `--acento` desde o primeiro pixel — inclusive na
// tela de configuração ausente, que precisa ser navegável por teclado tanto
// quanto qualquer outra. O convite público sobrescreve num contêiner.
document.documentElement.setAttribute('data-tema', 'purpura');

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('elemento #raiz não existe em index.html');

createRoot(raiz).render(
  <StrictMode>
    {leituraDaConfiguracao.ok ? (
      <App />
    ) : (
      // A aplicação não monta. Não é uma tela de erro dentro do app: é o app
      // recusando subir, que é o contrato do README.
      <ConfiguracaoAusente faltando={leituraDaConfiguracao.faltando} />
    )}
  </StrictMode>,
);
